import { t as e } from "./confirmation-Doy09wYN.js";
import { Button as t, Group as n, Modal as r, Stack as i, Text as a } from "@mantine/core";
import { startTransition as o, useCallback as s, useEffect as c, useRef as l, useState as u } from "react";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
import { IconAlertTriangle as p, IconCheck as m, IconX as h } from "@tabler/icons-react";
import { useBlocker as g, useLocation as _, useNavigate as v } from "react-router";
import { useDisclosure as y } from "@mantine/hooks";
// src/hooks/useBeforeUnload.ts
var b = (e) => {
	c(() => {
		if (!e) return;
		let t = (e) => {
			e.preventDefault();
		};
		return window.addEventListener("beforeunload", t), () => window.removeEventListener("beforeunload", t);
	}, [e]);
};
// src/hooks/useConfirmation.tsx
function x() {
	let [e, { open: o, close: c }] = y(!1), [l, g] = u(null), [_, v] = u(null), b = s((e) => new Promise((t) => {
		g(e), v(() => t), o();
	}), [o]), x = s(() => {
		_ && (_(!0), v(null)), c();
	}, [_, c]), S = s(() => {
		_ && (_(!1), v(null)), c();
	}, [_, c]);
	return {
		confirm: b,
		ConfirmationModal: s(() => {
			if (!l) return null;
			let { title: o = "Confirm Action", message: s, color: c = "blue", confirmText: u = "Confirm", cancelText: g = "Cancel", icon: _, centered: v = !0 } = l;
			return /* @__PURE__ */ d(r, {
				opened: e,
				onClose: S,
				title: /* @__PURE__ */ f(n, {
					gap: "xs",
					children: [_ || /* @__PURE__ */ d(p, { size: 20 }), /* @__PURE__ */ d(a, {
						size: "lg",
						fw: 600,
						children: o
					})]
				}),
				centered: v,
				children: /* @__PURE__ */ f(i, {
					gap: "md",
					children: [/* @__PURE__ */ d(a, {
						size: "sm",
						children: s
					}), /* @__PURE__ */ f(n, {
						justify: "flex-end",
						gap: "sm",
						children: [/* @__PURE__ */ d(t, {
							variant: "subtle",
							leftSection: /* @__PURE__ */ d(h, { size: 16 }),
							onClick: S,
							children: g
						}), /* @__PURE__ */ d(t, {
							color: c,
							leftSection: /* @__PURE__ */ d(m, { size: 16 }),
							variant: c === "red" ? "filled" : "light",
							onClick: x,
							children: u
						})]
					})]
				})
			});
		}, [
			e,
			l,
			x,
			S
		])
	};
}
// src/hooks/useDebounce.ts
function S(e, t) {
	let [n, r] = u(e);
	return c(() => {
		let n = setTimeout(() => {
			r(e);
		}, t);
		return () => {
			clearTimeout(n);
		};
	}, [e, t]), n;
}
// src/hooks/useHeapFormDraft.ts
var C = /* @__PURE__ */ new Map(), w = 3e5, T = 500, E = (e, t) => {
	if (t.length === 0) return e;
	let n = {};
	for (let r of Object.keys(e)) t.includes(r) || (n[r] = e[r]);
	return n;
}, D = (e, t, n = {}) => {
	let { enabled: r = !0, debounceMs: i = T, excludeFields: a = [] } = n, [o, d] = u(() => {
		if (!r) return !1;
		let e = C.get(t);
		return e ? Date.now() - e.timestamp > w ? (C.delete(t), !1) : !0 : !1;
	}), f = l(null), p = a.join(",");
	return c(() => {
		if (!r) return;
		f.current !== null && clearTimeout(f.current);
		let n = p ? p.split(",") : [], a = e.values;
		return f.current = setTimeout(() => {
			let e = E(a, n);
			C.set(t, {
				values: e,
				timestamp: Date.now()
			});
		}, i), () => {
			if (f.current !== null) {
				clearTimeout(f.current);
				let e = E(a, n);
				C.set(t, {
					values: e,
					timestamp: Date.now()
				});
			}
		};
	}, [
		r,
		t,
		i,
		e.values,
		p
	]), {
		hasDraft: o,
		restoreDraft: s(() => {
			let n = C.get(t);
			n && (Date.now() - n.timestamp > w ? (C.delete(t), d(!1)) : (e.setValues(n.values), C.delete(t), d(!1)));
		}, [t, e]),
		discardDraft: s(() => {
			C.delete(t), d(!1);
		}, [t]),
		captureNow: s(() => {
			if (!r) return;
			f.current !== null && (clearTimeout(f.current), f.current = null);
			let n = e.values, i = E(n, p ? p.split(",") : []);
			C.set(t, {
				values: i,
				timestamp: Date.now()
			});
		}, [
			t,
			r,
			e,
			p
		])
	};
}, O = () => {
	C.clear();
}, k = ({ active: e, confirm: t, confirmationPreset: n, confirmationMessage: r, submitCleanRef: i }) => {
	let a = g(e ? () => !i?.current : !1);
	c(() => {
		a.state === "blocked" && t({
			...n,
			...r && { message: r }
		}).then((e) => {
			e ? a.proceed?.() : a.reset?.();
		}).catch(() => {
			a.reset?.();
		});
	}, [
		a,
		t,
		n,
		r
	]);
};
// src/hooks/useFormProtection.ts
function A(t, n = {}) {
	let { enabled: r = !0, confirmationMessage: i, confirmationPreset: a = e.navigate, blockNavigation: d = !1, onDiscard: f } = n, { confirm: p, ConfirmationModal: m } = x(), [h, g] = u(!1), _ = l(!1);
	b(r && h), k({
		active: r && d && h,
		confirm: p,
		confirmationPreset: a,
		confirmationMessage: i,
		submitCleanRef: _
	});
	let v = s(() => {
		_.current = !0, t.resetDirty(), g(!1);
	}, [t]);
	return c(() => {
		if (!r) {
			o(() => {
				g(!1);
			});
			return;
		}
		let e = t.isDirty();
		e && (_.current = !1), o(() => {
			g((t) => t === e ? t : e);
		});
	}, [t.values, r]), {
		isDirty: h,
		checkProtection: s(async () => {
			if (!r || !h) return !0;
			try {
				let e = await p({
					...a,
					...i && { message: i }
				});
				return e && (f?.(), v()), e;
			} catch (e) {
				return console.error("Error in confirmation dialog:", e), !1;
			}
		}, [
			r,
			h,
			p,
			a,
			i,
			f,
			v
		]),
		markAsClean: v,
		markAsDirty: s(() => {
			g(!0);
		}, []),
		ConfirmationModal: m
	};
}
// src/hooks/useFormSubmission.ts
function j(e = 500) {
	let [t, n] = u(!1), [r, i] = u(0);
	return {
		isSubmitting: t,
		createSubmissionHandler: s((a) => async (o) => {
			let s = Date.now();
			if (!(s - r < e) && !t) try {
				n(!0), i(s), await a(o);
			} finally {
				n(!1);
			}
		}, [
			t,
			r,
			e
		])
	};
}
// src/hooks/useRouteAwareModal.tsx
var M = (e, t, n) => {
	let r = new URLSearchParams(e);
	if (t) for (let [e, n] of Object.entries(t)) n === void 0 || n === "" ? r.delete(e) : r.set(e, n);
	if (n) for (let e of n) r.delete(e);
	let i = r.toString();
	return i ? `?${i}` : "";
};
function N() {
	let e = _(), t = v();
	return {
		isModalOpen: s((t) => e.hash === `#${t}`, [e.hash]),
		openModal: s((n, r) => {
			let i = M(e.search, r), a = `${e.pathname}${i}#${n}`;
			t(a, { replace: !0 });
		}, [
			e.pathname,
			e.search,
			t
		]),
		closeModal: s((n) => {
			let r = M(e.search, void 0, n), i = `${e.pathname}${r}`;
			t(i, { replace: !0 });
		}, [
			e.pathname,
			e.search,
			t
		]),
		currentHash: e.hash.slice(1),
		currentSearch: e.search
	};
}
export { O as _resetHeapFormDraftStoreForTesting, b as useBeforeUnload, x as useConfirmation, S as useDebounce, A as useFormProtection, j as useFormSubmission, D as useHeapFormDraft, N as useModalUrlState, k as useNavigationBlocker };

//# sourceMappingURL=hooks.mjs.map